import * as React from 'react'

import styles from 'modules/core/components/BrowserBarPreview/index.module.scss'
import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  faviconImage: any
}

const _RealFavicon = ({ faviconImage }: Props) => {
  const src = faviconImage.preview ? faviconImage.preview : buildUrl(faviconImage)

  return <img className={styles.realFavicon} src={src} />
}

export default _RealFavicon
